import { ReactNode } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { BillingDataModal } from "./BillingDataModal";

interface BillingDataGateProps {
  children: ReactNode;
}

export const BillingDataGate = ({ children }: BillingDataGateProps) => {
  const { 
    isAuthenticated, 
    hasActiveSubscription, 
    hasBillingData, 
    loadingBillingData,
    loadingSubscription,
    isAdmin,
    isLifetimeSubscription,
    refreshBillingData 
  } = useAuth();

  // Non mostrare la modale mentre carica
  if (loadingBillingData || loadingSubscription) {
    return <>{children}</>;
  }

  // Mostra la modale obbligatoria solo se:
  // - Utente autenticato
  // - Ha un abbonamento attivo A PAGAMENTO (non lifetime gratuito)
  // - NON ha ancora i dati fiscali
  // Gli utenti lifetime possono inserire i dati volontariamente dalla pagina Subscription
  const shouldShowModal = 
    isAuthenticated && 
    hasActiveSubscription && 
    !hasBillingData && 
    !isLifetimeSubscription;

  const handleSuccess = async () => {
    await refreshBillingData();
  };

  return (
    <>
      {children}
      <BillingDataModal 
        open={shouldShowModal} 
        onSuccess={handleSuccess}
        editMode={false}
      />
    </>
  );
};
